



























































import { defineComponent, computed, Ref, ref } from '@vue/composition-api';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import axios from 'axios';

// Store
import { Endpoints, Mutations } from '@/ts/store/Constants';
import { Actions } from '@/ts/store/modules/Channels/constants';
import ErrorResponse from '@/ts/ErrorResponse';

// Components
import BrandButton from '@/components/NEW-STRUCTURE/mobile/buttons/BrandButton.vue';
import MobileHeader from '@/components/NEW-STRUCTURE/mobile/layout/MobileHeader.vue';
import FormDialogCard from '../components/FormDialogCard.vue';
import SlideUpDialog from '@/components/NEW-STRUCTURE/mobile/dialogs/SlideUpDialog.vue';
import TextInput from '../components/TextInput.vue';
import TextAreaInput from '../components/TextAreaInput.vue';
import BackButton from '../components/BackButton.vue';

export default defineComponent({
    props: [
        'value',
    ],
    emits: [
        'input',
    ],
    components: {
        SlideUpDialog,
        FormDialogCard,
        BrandButton,
        MobileHeader,
        TextInput,
        TextAreaInput,
        ValidationObserver,
        ValidationProvider,
        BackButton,
    },
    setup(props, context) {
    const store = context.root.$store;

  const name: Ref<string> = ref('');
  const description: Ref<string> = ref('');

  const showForm = computed({
            get() {
                return props.value;
            },
            set(newValue) {
                if (newValue === false) {
                    name.value = '';
                    description.value = '';
                }

                context.emit('input', newValue);            
            },
        });

  const onCloseClicked = () => {
            showForm.value = false;
        };

  const onSubmit = async (e) => {
            // @ts-ignore
            const isValid = await context.refs.observer.validate();

            if (isValid) {
                const requestData = new FormData();

                if (name.value) { requestData.append('name', name.value); }
                if (description.value) { requestData.append('description', description.value); }
    
                axios.post(Endpoints.Channels.CREATE_CHANNEL, requestData)
                    .then(() => {
                        store.dispatch(Actions.FETCH_JOINED_CHANNEL_LIST);
                           store.dispatch(Actions.FETCH_AVAILABLE_CHANNEL_LIST);
                        showForm.value = false;
                    })
                    .catch((error) => {
                        if (error.response && error.response.data && error.response.data.errors) {
                            const errors = error.response.data.errors;
                            if (errors.name && errors.name.length > 0) {
                                /* eslint-disable no-eval */
                                // @ts-ignore
                                context.refs.nameProvider.applyResult({
                                    // @ts-ignore
                                    errors: [ context.root.$t('channels.validation.name-has-been-taken', 'The name has been taken') ],
                                    valid: false,
                                    failedRules: {},
                                });
                                return;
                            }
                        }

                        if (error.response) {
                            const errorResponse = new ErrorResponse(error.response.status, error.response.data.message);
                            store.commit(Mutations.ADD_ERROR_RESPONSE, errorResponse);
                        } else {
                            console.log(error);
                        }
                    });
            }
        };

  return {
            showForm,
            onCloseClicked,
            name,
            description,
            onSubmit,
        };
        
    },
});
